module.exports = __webpack_public_path__ + "img/user-4.b5923b96.png";